import React, { useState, useEffect, use } from 'react'
import moment from 'moment'
import { Pagination } from '@mui/material';
import { getSingularDasboardDataAPI, getSingularDasboardReportAPI, getAllPartnerNameByAggregatorNameAPI, getdistinctEventNamesforFilteration, getAllAgrregatorNames, DeleteEventByID, AddEventUsingData, UpdateEventUsingData } from '../../actioncreator';
import Loader from '../../../../../presentationals/Loader/Loader.component';
import Nodata from '../../../../../../images/nodata.png'
import CustomMultiSelect from './CustomMultiselect'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../../../reducers/CommonFilters.reducer';

const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

export default function SingularDashboard() {
    const itemsPerPage = 10;
    const dispatch = useDispatch();
    const { fromDate: ReducerFrom, toDate: ReducerTo } = useSelector(state => state.FilterReduce.commonFilters);
    const [loader, setLoader] = useState(false)
    const [filterType, setFilterType] = useState('applicationNo')
    const [fromDate, setFromDate] = useState(ReducerFrom)
    const [toDate, setToDate] = useState(ReducerTo)
    const [filterValue, setFilterValue] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([])
    const [totalData, setTotalData] = useState('')
    const [partnerName, setPartneName] = useState([])
    const [aggregatorName, setaggregatorName] = useState([])
    const [selectedCheckboxValues, setselectedCheckboxValues] = useState({ partnerName: [], aggregatorName: [] })
    const [overallAggregatorData, setOverallAggregatorData] = useState({})
    const [showDownload, setshowDownload] = useState(false)
    const [eventNameList, setEventNameList] = useState([])
    const [eventName, setEventName] = useState("")
    const [showPartnerpopup, setShowPartnerPopup] = useState(false)

    const filterHandler = (e) => {
        setFilterType(e.target.value)
    }

    useEffect(() => {
        setFromDate(ReducerFrom)
        setToDate(ReducerTo)
        getAllPartnerNameByAggregatorNameFunction()
        getdistinctEventNamesforFilterationFunction()
        APIFunction(ReducerFrom, ReducerTo, currentPage, selectedCheckboxValues.partnerName, selectedCheckboxValues.aggregatorName, eventName)
    }, [ReducerFrom, ReducerTo])

    const dataFilter = (e, type) => {
        if (type === 'filter') {
            setshowDownload(false)
            setFilterValue(e.target.value)
        } else if (type === "fromDate") {
            setshowDownload(false)
            dispatch({ type: FILTER_ACTION, payload: { fromDate: e.target.value } });
            setFromDate(e.target.value)
        } else if (type === "toDate") {
            setshowDownload(false)
            dispatch({ type: FILTER_ACTION, payload: { toDate: e.target.value } });
            setToDate(e.target.value)
        } else if (type === "eventName") {
            setshowDownload(false)
            setEventName(e.target.value)
        } else if (type === "apply") {
            setCurrentPage(1);
            APIFunction(fromDate, toDate, 1, selectedCheckboxValues.partnerName, selectedCheckboxValues.aggregatorName, eventName)
        } else if (type === "clear") {
            setshowDownload(false)
            setFilterType('applicationNo')
            setFromDate(InitalDate('fromDate'))
            setToDate(InitalDate('toDate'))
            setCurrentPage(1);
            setselectedCheckboxValues({ partnerName: [], aggregatorName: [] })
            APIFunction(InitalDate('fromDate'), InitalDate('toDate'), 1, '', '', '')
            setEventName("")
        }
    }

    // useEffect(() => {
    //     getAllPartnerNameByAggregatorNameFunction()
    //     getdistinctEventNamesforFilterationFunction()
    //     APIFunction(fromDate, toDate, currentPage, selectedCheckboxValues.partnerName, selectedCheckboxValues.aggregatorName, eventName)
    // }, [])

    const getdistinctEventNamesforFilterationFunction = () => {
        // getdistinctEventNamesforFilteration(callback => {
        getAllAgrregatorNames(callback => {
            if (callback?.length > 0) {
                setEventNameList(callback)
            } else {
                setEventNameList([])
            }
        })
    }

    const getAllPartnerNameByAggregatorNameFunction = () => {
        getAllPartnerNameByAggregatorNameAPI((callback) => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setOverallAggregatorData(callback?.data)
                setPartneName(callback?.data?.partnerList)
                if (callback && callback?.data && callback?.data?.aggregator && Object.keys(callback?.data?.aggregator)?.length > 0) {
                    const list = Object.keys(callback?.data?.aggregator)
                    setaggregatorName(list)
                    console.log(list)
                } else {
                    setaggregatorName([])
                }
            } else {
                setPartneName([])
                setaggregatorName([])

            }
        })
    }

    const APIFunction = (sDate, eDate, currentPageNo, partnerNameArray, aggregatorNameArray, eventName) => {
        console.log(selectedCheckboxValues)
        const formattedFromDate = moment(sDate).format('DD-MM-YYYY');
        const formattedToDate = moment(eDate).format('DD-MM-YYYY');
        const obj = {
            pageNo: currentPageNo,
            size: itemsPerPage,
            sDate: formattedFromDate,
            eDate: formattedToDate,
            applicationId: filterType === 'applicationNo' ? filterValue : '',
            email: filterType === 'email' ? filterValue : '',
            partnerName: partnerNameArray,
            companyList: aggregatorNameArray,
            eventName: eventName
        }
        setLoader(true)
        getSingularDasboardDataAPI(obj, (callback) => {
            setLoader(false)
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success" && callback?.data) {
                setData(callback?.data?.data)
                setTotalData(callback?.data?.count)
                if (callback?.data?.data && callback?.data?.data?.length > 0) {
                    setshowDownload(true)
                } else {
                    setshowDownload(false)
                }
            } else {
                setshowDownload(true)
                setData([])
            }
        })
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        APIFunction(fromDate, toDate, value, selectedCheckboxValues.partnerName, selectedCheckboxValues.aggregatorName, eventName)
    };


    const downloadFile = () => {
        const formattedFromDate = moment(fromDate).format('DD-MM-YYYY');
        const formattedToDate = moment(toDate).format('DD-MM-YYYY');
        const obj = {
            pageNo: currentPage,
            size: totalData,
            sDate: formattedFromDate,
            eDate: formattedToDate,
            applicationId: filterType === 'applicationNo' ? filterValue : '',
            email: filterType === 'email' ? filterValue : '',
            partnerName: selectedCheckboxValues.partnerName,
            companyList: selectedCheckboxValues.aggregatorName,
            eventName: eventName
        }
        setLoader(true)
        getSingularDasboardReportAPI(obj, (callback) => {
            setLoader(false)
            // console.log(callback)
        })
    }

    const handleCustomSelectBoxChange = (e, type) => {
        console.log(e, type)
        setshowDownload(false)
        if (type === "aggregatorName") {
            if (e?.length > 0) {
                let aggregatedValues = [];
                e.forEach((key) => {
                    if (overallAggregatorData?.aggregator?.[key]) {
                        aggregatedValues = [...aggregatedValues, ...overallAggregatorData.aggregator[key]];
                    }
                });
                aggregatedValues = [...new Set(aggregatedValues)];
                console.log("Aggregated Values:", aggregatedValues);
                setPartneName(aggregatedValues);
            } else {
                setPartneName(overallAggregatorData?.partnerList)
            }
            setselectedCheckboxValues((prev) => ({
                ...prev,
                'aggregatorName': e
            }))
        } else {
            setselectedCheckboxValues((prev) => ({
                ...prev,
                'partnerName': e
            }))
        }
    }

    const handlePartnerPopup = () => {
        setShowPartnerPopup(!showPartnerpopup)
    }


    return (
        <>
            <div className="SingularDashboard">
                {
                    loader ? <Loader /> : ''
                }
                <div className="container-fluid">
                    <div className="filterSection">
                        <div className="row">
                            <div className="col-sm-2 col-xs-12">
                                <label htmlFor="" style={{ fontSize: '12px' }}>Select Filter</label>
                                <span className="main-search" >
                                    <select className="form-control main-select" style={{ background: '#DBE9FF', fontWeight: '700' }} onChange={(e) => filterHandler(e)}>
                                        <option value="applicationNo">Application no</option>
                                        <option value="email">Email</option>
                                        {/* <option value="partnerName">Partner Name</option> */}
                                    </select>
                                    <input type="text" value={filterValue} className="form-control inputTag" onChange={e => dataFilter(e, 'filter')} placeholder="Search.." />

                                </span>
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <label htmlFor="" style={{ fontSize: '12px' }}>From</label>
                                <input type="date" id="customDateInput" className="form-control" value={fromDate} style={{ marginTop: '0px' }} onChange={e => dataFilter(e, 'fromDate')} />
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <label htmlFor="" style={{ fontSize: '12px' }}>To</label>
                                <input type="date" id="customDateInput" className="form-control" value={toDate} style={{ marginTop: '0px' }} onChange={e => dataFilter(e, 'toDate')} />
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <label htmlFor="" style={{ fontSize: '12px' }}>Select Aggregator Name</label>
                                <CustomMultiSelect OptionValues={aggregatorName} selectedValues={selectedCheckboxValues.aggregatorName} onChange={(e) => handleCustomSelectBoxChange(e, 'aggregatorName')} placeholder={''} />
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <label htmlFor="" style={{ fontSize: '12px' }}>Select Partner Name</label>
                                <CustomMultiSelect OptionValues={partnerName} selectedValues={selectedCheckboxValues.partnerName} onChange={(e) => handleCustomSelectBoxChange(e, 'partnerName')} placeholder={''} />
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <label htmlFor="" style={{ fontSize: '12px' }}>Select Event Name</label>
                                <select className="form-control" value={eventName} onChange={(e) => dataFilter(e, "eventName")} style={{ marginTop: '1px' }}>
                                    <option value="">Select Option</option>
                                    {
                                        eventNameList?.length > 0 ? eventNameList?.map((value, id) => {
                                            return (
                                                <option value={value?.eventName}>{`${value?.eventOrder} - ${value?.eventName}`}</option>
                                            )
                                        })
                                            : ""}

                                </select>

                            </div>
                        </div>
                        <div className="row">

                            <div className="col-sm-5 col-xs-12" >
                                <div className='filterbtns' >
                                    <button className="btn btn-primary" style={{ marginTop: '24px', marginRight: '10px' }} onClick={e => dataFilter(e, 'apply')}>Apply Filter</button>
                                    {
                                        showDownload == true && data && data?.length > 0 ?
                                            <button className="btn btn-primary" style={{ marginTop: '24px', marginRight: '10px' }} onClick={e => downloadFile(e)}><i className='fa fa-download'></i>&nbsp;&nbsp;Download</button>
                                            : ''}
                                    <button className="btn reset-btn" style={{ marginTop: '24px', marginRight: '10px' }} onClick={e => dataFilter(e, 'clear')}>Clear Filter</button>
                                    <button className="btn btn-primary" style={{ marginTop: '24px' }} onClick={e => handlePartnerPopup()}>View/Edit Event Partner</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        data && data?.length > 0 ?
                            <div>
                                <div className="overflow-x-auto phocket-table-new">
                                    <table >
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Partner Name</th>
                                                <th className='text-center'>Application Id</th>
                                                <th className='text-center'>Approved Amount</th>
                                                <th className='text-center'>Name</th>
                                                <th className='text-center'>Mobile Number</th>
                                                <th className='text-center'>Email Id</th>
                                                <th className='text-center'>Net Take Home Salary</th>
                                                <th className='text-center'>State</th>
                                                <th className='text-center'>Singular Event Name</th>
                                                <th className='text-center'>Approve Date</th>
                                                <th className='text-center'>Disburse Date</th>
                                                <th className='text-center'>Loan Status</th>
                                                <th className='text-center'>Reject Reason</th>
                                                <th className='text-center'>Customer Type</th>
                                                <th className='text-center'>Apply Date</th>
                                                <th className='text-center'>EventTimestamp</th>
                                                <th className='text-center'>Publisher Id</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data && data?.map((value, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className='text-center'>{value?.partnerName || '-'}</td>
                                                            <td className='text-center'>{value?.applicationId || '-'}</td>
                                                            <td className='text-center'>{value?.approvedAmount || '-'}</td>
                                                            <td className='text-center'>{value?.name || '-'}</td>
                                                            <td className='text-center'>{value?.mobileNumber || '-'}</td>
                                                            <td className='text-center'>{value?.emailId || '-'}</td>
                                                            <td className='text-center'>{value?.takeHomeSalary || '-'}</td>
                                                            <td className='text-center'>{value?.state || '-'}</td>
                                                            <td className='text-center'>{value?.singularEventName || '-'}</td>
                                                            <td className='text-center'>{value?.approveDate || '-'}</td>
                                                            <td className='text-center'>{value?.disburseDate || '-'}</td>
                                                            <td className='text-center'>{value?.loanStatus || '-'}</td>
                                                            <td className='text-center'>{value?.rejectReason || '-'}</td>
                                                            <td className='text-center'>{value?.customerType || '-'}</td>
                                                            <td className='text-center'>{value?.applyDate || '-'}</td>
                                                            <td className='text-center'>{value?.eventTimestamp || '-'}</td>
                                                            <td className='text-center'>{value?.publisherId || '-'}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className='' style={{ display: 'flex', justifyContent: 'flex-end', marginTop: window.innerWidth > 1850 ? '20px' : '10px' }}>
                                    <Pagination
                                        count={Math.ceil(totalData / itemsPerPage)}
                                        page={currentPage}
                                        onChange={(event, value) => handlePageChange(event, value)}
                                        color="success"
                                    />

                                </div>

                            </div>
                            :
                            <div className="text-center" style={{ marginTop: '40px', marginBottom: '20px' }}><img width={'50%'} src={Nodata} /></div>

                    }
                </div>
            </div>

            {
                showPartnerpopup ?
                    <PartnerPopup handlePartnerPopup={handlePartnerPopup} eventNameList={eventNameList} getApicall={getdistinctEventNamesforFilterationFunction} />
                    : ""}
        </>
    )
}

const PartnerPopup = ({ handlePartnerPopup, eventNameList, getApicall }) => {

    const [activeTab, setActiveTab] = useState("list")
    const [editData, setEditData] = useState({})
    const [obj, setObj] = useState({
        eventOrder: "",
        eventName: "",
        aggregatorType: "",
    })

    const handleTab = (type) => {
        setActiveTab(type)
        if (type == "list") {
            setObj({
                eventOrder: "",
                eventName: "",
                aggregatorType: "",
            })
        }
        setEditData({})
    }

    const handlechange = (e, type) => {
        setObj((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleDelete = (id) => {
        DeleteEventByID(id, callback => {
            getApicall()
        })
    }

    const handleEdit = (data) => {
        handleTab("add")
        setEditData(data)
        setObj({
            eventOrder: data?.eventOrder,
            eventName: data?.eventName,
            aggregatorType: data?.aggregatorType,
        })
    }


    const handleSave = () => {
        if (editData?.id) {
            const data = { ...obj }
            UpdateEventUsingData(editData?.id, data, callback => {
                handleTab("list")
                getApicall()
            })

        } else {
            const data = { ...obj }
            AddEventUsingData(data, callback => {
                handleTab("list")
                getApicall()
            })
        }
    }
    return (
        <>
            <div className="background-blur" style={{ zIndex: '3' }}>

                <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                    <i onClick={() => handlePartnerPopup()} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                    <div className="row from-group">
                        <div className="col-xs-12" style={{ padding: '10px' }}>
                            <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Event Partner</h4>
                        </div>
                    </div>

                    <div className="row from-group">
                        <div className="col-xs-12" style={{ display: 'flex', gap: '10px' }}>
                            <div className={`expenseListTab ${activeTab == "list" ? "active" : ""} text-center`} onClick={() => handleTab("list")}><i className='fa fa-list'></i></div>
                            <div className={`expenseListTab ${activeTab == "add" ? "active" : ""} text-center`} onClick={() => handleTab("add")}><i className='fa fa-plus'></i></div>
                        </div>
                    </div>
                    {
                        activeTab == "list" ?
                            eventNameList?.length > 0 ?
                                <div className="row from-group">
                                    <div className="col-xs-12 col-xs-12">
                                        <div className="overflow-x-auto phocket-table-new" style={{ overflowY: 'auto', maxHeight: '300px' }}>
                                            <table >
                                                <thead style={{ position: 'sticky', top: '0' }}>
                                                    <tr>
                                                        <th className='text-center'>Event Order</th>
                                                        <th className='text-center'>Event Name</th>
                                                        <th className='text-center'>Edit</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        eventNameList && eventNameList?.map((value, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className='text-center'>{value?.eventOrder ?? '-'}</td>
                                                                    <td className='text-center'>{value?.eventName || '-'}</td>
                                                                    <td className='text-center' style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                                                                        <button onClick={() => handleEdit(value)}><i className='fa fa-edit'></i></button>
                                                                        <button onClick={() => handleDelete(value?.id)}><i className='fa fa-trash'></i></button>
                                                                    </td>

                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                : "" : ""}

                    {
                        activeTab == "add" ?
                            <div className="row from-group " style={{ marginTop: '30px' }}>
                                <div className="col-xs-12 col-sm-4">
                                    <label>Event Order</label>
                                    <input type='number' className='form-control' value={obj?.eventOrder} onChange={(e) => handlechange(e, "eventOrder")} />
                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    <label>Event Name</label>
                                    <input type='text' className='form-control' value={obj?.eventName} onChange={(e) => handlechange(e, "eventName")} />
                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    <label>Aggregator Type</label>
                                    <select className='form-control' value={obj?.aggregatorType} onChange={(e) => handlechange(e, "aggregatorType")}>
                                        <option value={""}>Select Option</option>
                                        <option value={"Singular"}>Singular</option>
                                    </select>
                                </div>
                                <div className="col-xs-12 text-center" style={{ marginTop: '20px' }}>
                                    <button className="btn btn-primary" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => handleSave()}>Save</button>
                                </div>
                            </div>
                            : ""}
                </div>
            </div>
        </>
    )
}